import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	viewScriptButton: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.button.see-script.non-final',
		defaultMessage: 'See AI script',
		description: 'Label for the button to show the auto-generated Loom script',
	},
	readTimeImprovementLabel: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.readtime.readability-label.non-final',
		defaultMessage: 'Improve your page',
		description:
			'Small helper label shown above the Loom suggestion, indicating this section provides tips to improve readability',
	},
	readTimeLoomAIScriptLabel: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.readtime.loom-label.non-final',
		defaultMessage: 'Summary video',
		description:
			'Main headline in the read time panel encouraging users to create a Loom video to summarize the page content',
	},
	recordButton: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.button.record.non-final',
		defaultMessage: 'Record',
		description: 'Button label for recording a Loom video from the read time panel',
	},
	recordCrossFlowButton: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.button.record-cross-flow.non-final',
		defaultMessage: 'Record with AI script',
		description:
			'Button label for recording a Loom video from the read time panel for cross flow (when tenant does not have Loom)',
	},
	tryLozenge: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.try-lozenge.non-final',
		defaultMessage: 'Try',
		description: 'Label for the try lozenge in the read time panel',
	},
	spotlightButtonLabel: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.spotlight.button-label.non-final',
		defaultMessage: 'Got it',
		description: 'CTA button label for spotlight highlighting the Add summary video feature',
	},
	spotlightHeading: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.spotlight.title.non-final',
		defaultMessage: 'Improve your page with a video',
		description: 'Title for spotlight highlighting the Add summary video feature',
	},
	spotlightBody: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.spotlight.description.non-final',
		defaultMessage: 'Record a summary video to get everyone aligned quickly.',
		description: 'Description for spotlight highlighting the Add summary video feature',
	},
	rovoSpotlightHeading: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.rovo-spotlight.title.non-final',
		defaultMessage: 'Here’s a script for your summary video',
		description:
			'Title for spotlight highlighting the Rovo sidebar when generating a summary script for them',
	},
	rovoSpotlightBody: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.rovo-spotlight.body.non-final',
		defaultMessage: 'Review the AI script and hit ‘Record video’ at the bottom to get started.',
		description:
			'Description for spotlight highlighting the Rovo sidebar when generating a summary script for them',
	},
	rovoSpotlightButtonLabel: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.rovo-spotlight.button-label.non-final',
		defaultMessage: 'Got it',
		description:
			'Button label for spotlight highlighting the Rovo sidebar when generating a summary script for them',
	},
});
